module.exports = __webpack_public_path__ + "static/media/10. B2, Superficie sólida, 20 x 33 x 20 cm, 2019 copy.d39e320b.png";